module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "height": "100%",
      "padding": "0"
    },
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "fill-height": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('AdminSideBarMenu'), _vm._v(" "), (_vm.isSelectedTab('all')) ? _c('v-flex', {
    staticClass: "dashboard-view"
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Admin Tutorials")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("All Tutorials")])], 1), _vm._v(" "), _c('all-tutorial')], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('manage')) ? _c('v-flex', {
    staticClass: "dashboard-view"
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Admin Tutorials")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Manage Tutorials")])], 1), _vm._v(" "), _c('tutorial-table')], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('tutorial-new')) ? _c('v-flex', {
    staticClass: "dashboard-view"
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Admin Tutorials")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Add New Tutorial")])], 1), _vm._v(" "), _c('new-tutorial')], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d981da2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/TutorialView.vue
// module id = 1728
// module chunks = 5